import { message } from 'antd';
import { useEffect, useState } from 'react';

export type SingleApiReducerReturnType<T> = [T | undefined, () => Promise<unknown>];

export const singleApiReducer = <T, IdType>(fetchFunction: (id: IdType) => Promise<T>) => {
	return (id?: IdType): SingleApiReducerReturnType<T> => {
		const [data, setData] = useState<T>();

		const fetchData = async (id: IdType) => {
			try {
				const result = await fetchFunction(id);

				setData(result);
			} catch (e) {
				console.error(e);

				message.error(`Nie udało się pobrać danych (${e})`);
			}
		};

		useEffect(() => {
			if (!id) {
				return;
			}

			fetchData(id);
		}, [id]);

		return [data, async () => id && fetchData(id)];
	};
};
